export interface ArtikelAttribut {
  id: number;
  parentId: number;
  name: string;
  title: string;
  itemCount: number;
}
